import {RouteRecordRaw} from "vue-router";
import Login from "@/views/Login.vue";
import Logout from "@/views/Logout.vue";
import Register from '@/views/Register.vue';

export const routes: RouteRecordRaw[] = [
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {noLogin: true}
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
  },
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: {noLogin: true}
  },
];

